import React from 'react';
import { Link } from 'react-router-dom';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/ui/Card';
import {
  PageLayout,
  PageContent,
  PageTitle,
  PageDescription,
} from '@/components/PageLayout';
import { ArrowRight } from 'lucide-react';

// Sample blog posts data
const blogPosts = [
  {
    id: 1,
    title: 'Getting Started with Codii',
    excerpt: 'A beginner-friendly guide to setting up and using our application for the first time.',
    slug: 'getting-started',
    date: 'June 10, 2025',
    author: 'Codii Team',
  },
  {
    id: 2,
    title: 'Advanced Features You Should Know',
    excerpt: 'Dive deep into the advanced features that can boost your productivity and code quality.',
    slug: 'advanced-features',
    date: 'June 15, 2025',
    author: 'Codii Team',
  },
  {
    id: 3,
    title: 'Understanding AI-Powered Code Reviews',
    excerpt: 'A look into how AI is changing the landscape of code reviews and how Codii leverages it.',
    slug: 'ai-code-reviews',
    date: 'June 20, 2025',
    author: 'Codii Team',
  },
];

const BlogPage: React.FC = () => {
  return (
    <PageLayout>
      <PageContent>
        <div className="text-center mb-12">
          <PageTitle>Our Blog</PageTitle>
          <PageDescription className="max-w-2xl mx-auto">
            Welcome to our blog! Here we share the latest news, updates, and tutorials about Codii.
          </PageDescription>
        </div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {blogPosts.map((post) => (
            <Link to={`/blog/${post.slug}`} key={post.id} className="group block">
              <Card className="h-full flex flex-col transition-all duration-200 hover:shadow-lg hover:-translate-y-1 hover:border-primary/30">
                <CardHeader>
                  <CardTitle className="group-hover:text-primary transition-colors">
                    {post.title}
                  </CardTitle>
                  <p className="text-sm text-muted-foreground pt-1">{post.date} by {post.author}</p>
                </CardHeader>
                <CardContent className="flex-grow">
                  <CardDescription>{post.excerpt}</CardDescription>
                </CardContent>
                <div className="p-6 pt-0 flex justify-end">
                    <div className="flex items-center text-primary font-semibold text-sm opacity-0 group-hover:opacity-100 transition-opacity">
                        Read More
                        <ArrowRight className="w-4 h-4 ml-1 transition-transform group-hover:translate-x-1" />
                    </div>
                </div>
              </Card>
            </Link>
          ))}
        </div>
      </PageContent>
    </PageLayout>
  );
};

export default BlogPage;
